export class RoleEndpoint {
    endpointId: string;
    endpointUri: string;
    id: string;
    resourceId: string;
    roleId: string;
}